
import React, { useEffect, useMemo, useState } from "react";
import ReactEcharts from "echarts-for-react";
import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';
import Finance_bannerImg from "../../assets/images/finance_banner.jpg";
import TreadingarrowDown from "../../assets/images/treading-arrow-down.png"
import TreadingarrowUp from '../../assets/images/treading-arrow-up.png';
import { toMillion } from "../../utils";
import LoaderContainer from "../../components/LoaderContainer/LoaderContainer";
import { fetchFinancial_top_tile, fetchFinancial_Total_Revenue_piechart, fetchFinancial_Total_Expenses_piechart } from "../../redux/slices/counter";
import { useDispatch, useSelector } from "react-redux";

export default function FinancialInformation() {

  const dispatch = useDispatch()

  const [Expenses, Revenue] = useSelector(state => state.netsales.Financial_top_tile);
  const Financial_top_tileDataloading = useSelector(state => state.netsales.Financial_top_tileloading);

  const Financial_Total_Revenue_piechart = useSelector(state => state.netsales.Financial_Total_Revenue_piechart);
  const Financial_Total_Revenue_piechartloading = useSelector(state => state.netsales.Financial_Total_Revenue_piechartloading);

  const Financial_Total_Expenses_piechart = useSelector(state => state.netsales.Financial_Total_Expenses_piechart);
  const Financial_Total_Expenses_piechartloading = useSelector(state => state.netsales.Financial_Total_Revenue_piechartloading);

  const appliedfilter = useSelector(state => state.filter.appliedFilters);

  useEffect(() => {
    dispatch(fetchFinancial_top_tile({
      "elasticQueryName": "Financial_top_tile",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
    dispatch(fetchFinancial_Total_Revenue_piechart({
      "elasticQueryName": "Financial_Total_Revenue_piechart",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
    dispatch(fetchFinancial_Total_Expenses_piechart({
      "elasticQueryName": "Financial_Total_Revenue_piechart",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
  }, []);

const FinInfo1 = {
  textStyle: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: 10,
    color: "#fff",
  },

  title: {
    text: "Revenue",
    textStyle: {
      fontSize: 16,
      fontWeight: 400,
      color: "#ffffff",
      fontFamily: "Inter, sans-serif",
    },
  },

  tooltip: {
    trigger: "item",
    formatter: function (params) {
      return (
        params.name +
        " : " +
        toMillion(params.value) +
        " (" +
        params.percent.toFixed(1) +
        "%)"
      );
    },
    confine: true,
    axisPointer: {
      type: "shadow",
    },
  },

  legend: {
    orient: "vertical",
    right: "12%",
    top: "middle",
    bottom: 10,
    itemWidth: 6,
    itemHeight: 6,
    itemGap: 4,
    formatter: (name) =>
      name.length > 25 ? name.substring(0, 23) + "...  " : name,
    textStyle: {
      color: "#fff",
      fontSize: 10,
      fontWeight: 500,
      fontFamily: "Inter, sans-serif",
      width: 90,
    },
    pageIconSize: 12,
    pageIconColor: "#fff",
    pageIconInactiveColor: "#666",
    pageTextStyle: {
      color: "#fff",
    },
  },

  color: [
    "#E99F4F",
    "#335D76",
    "#B55D5D",
    "#498E71",
    "#3A3365",
    "#2b79b3",
    "#2b3d82",
    "#6f2e66",
    "#6f2e66",
    "#2C7AB8",
    "#402B50",
  ],

  series: [
    {
      type: "pie",
      radius: "75%",
      bottom: "12%",
      center: ["25%", "60%"],
      avoidLabelOverlap: true,

      label: {
        show: true,
        position: "inside",
        formatter: ({ percent }) => `${percent.toFixed(1)}%`,
        textStyle: {
          fontSize: 11,
          fontWeight: 600,
          color: "#fff",
          fontFamily: "Inter, sans-serif",
        },
      },

      emphasis: {
        label: { show: false },
      },

      labelLine: {
        show: false,
      },

      data: Financial_Total_Revenue_piechart?.map((item) => ({
        name: item?.SUB_METRIC_NAME,
        value: parseFloat(item?.VALUE),
      })),
    },
  ],
};
  const memoizedChartOption = useMemo(() => FinInfo1, [Financial_Total_Revenue_piechart]);


  const MyChart = React.memo(({ options }) => {
    return <ReactEcharts option={options} notMerge={true} lazyUpdate={true} style={{ width: 350 }} />;
  });

  const customString = (param) => {

    return param

  }

const FinInfo2 = {
  textStyle: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: 12,
    color: "#fff",
  },

  title: {
    text: "Expenses",
    textStyle: {
      fontSize: 16,
      fontWeight: "400",
      color: "#ffffff",
      fontFamily: "Inter, sans-serif",
    },
  },

  tooltip: {
    trigger: "item",
    formatter: function (params) {
      return (
        params.name +
        " : " +
        toMillion(params.value) +
        " (" +
        params.percent.toFixed(1) +
        "%)"
      );
    },
    axisPointer: { type: "shadow" },
    confine: true,
  },

  legend: {
    orient: "vertical",
    right: "12%",
    top: "middle",
    bottom: 10,
    itemWidth: 6,
    itemHeight: 6,
    itemGap: 4,
    formatter: (name) =>
      name.length > 25 ? name.substring(0, 23) + "...  " : name,
    textStyle: {
      color: "#fff",
      fontSize: 10,
      fontWeight: 500,
      fontFamily: "Inter, sans-serif",
      width: 90,
    },
    pageIconSize: 12,
    pageIconColor: "#fff",
    pageIconInactiveColor: "#666",
    pageTextStyle: { color: "#fff" },
  },

  color: [
    "#E99F4F",
    "#335D76",
    "#B55D5D",
    "#498E71",
    "#3A3365",
    "#2b79b3",
    "#2b3d82",
    "#6f2e66",
    "#6f2e66",
    "#2C7AB8",
    "#402B50",
  ],

  series: [
    {
      type: "pie",
      radius: "75%",
      bottom: "12%",
      center: ["25%", "60%"],
      avoidLabelOverlap: true,

      label: {
        show: true,
        position: "inside",
        formatter: ({ percent }) => `${percent.toFixed(1)}%`,
        textStyle: {
          fontSize: 11,
          fontWeight: 600,
          color: "#fff",
          fontFamily: "Inter, sans-serif",
        },
      },

      labelLine: { show: false },

      data: Financial_Total_Expenses_piechart?.map((item) => ({
        name: item?.SUB_METRIC_NAME,
        value: parseFloat(item?.VALUE?.replace(",", "")),
      })),
    },
  ],
};

  const RevenueExpense = {
    title: {
      text: 'Revenue and Expense over the year',
      left: 10,
      textStyle: {
        fontSize: 12,
        fontWeight: "normal",
        color: '#fff',
      },
    },
    legend: {
      data: ['Revenue', 'Expense'],

      left: 0,
      right: "0%",
      // bottom:"10%",
      itemWidth: 6,
      itemHeight: 6,
      top: '24%',
      textStyle: {
        color: "#fff",
        fontSize: '11',
        fontStyle: 'normal',
      },
    },


    tooltip: {

      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: "#333",
      textStyle: {
        fontSize: 12,
        fontWeight: "normal",
        color: '#fff',
      },
      trigger: 'axis',
      // formatter: function(params) {
      //   return (
      //     params.name + " : " + toMillion(params.value)
      //   );
      // },
      axisPointer: {
        type: 'line',
        lineStyle: {
          type: "line"
        }
      },


    },
    grid: {
      tooltip: {
        padding: [50, 100, 100, 100],
        color: '#fff'
      }
    },

    // grid: {

    //   right: '0%',
    //   bottom: '0%',
    //   top: '0%',
    //   width: '150%',
    //   height: '120%',
    //   left: '-22%',
    //   containLabel: true
    // },

    // yAxis: [
    //  { type: 'value'}
    // ],
    // xAxis: {
    //   boundaryGap: false,
    //   type: 'category',
    //   data: ['2015', '2016', '2017', '2018'],

    // },
    // color: ['#359760','#2b3d82'],
    // series: [
    //   {
    //     data: [2000, 1000, 2000, 500],
    //     type: 'line',
    //     colorBy: "data",
    //     areaStyle: {},
    //     label: {
    //       show: true,
    //       position: 'top',
    //       textShadowBlur: 0,
    //       color: '#fff'
    //     },
    //   },
    //   {
    //     data: [1000, 500, 2000, 3000],
    //     type: 'line',
    //     colorBy: "data",
    //     areaStyle: {},
    //     label: {
    //       show: true,
    //       position: 'top',
    //       textShadowBlur: 0,
    //       color: '#fff'
    //     },
    //   },
    // ]
    grid: {
      left: '8%',
      right: '2%',
      bottom: '0%',
      width: '80%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: false,
        data: ['2019', '2020', '2021', '2024'],
        splitLine: { show: false },
        axisLabel: {
          inside: true,
          color: '#fff'
        },
        z: 10
      }
    ],
    yAxis: [
      {
        type: 'value', splitLine: { show: false }, axisLabel: {
          show: false
        }

      }
    ],
    color: ['#2b3d82', '#359760'],
    series: [


      {
        name: 'Revenue',
        type: 'line',
        stack: 'Total',
        areaStyle: {},
        label: {
          show: false,
          position: 'top',
          color: '#fff'
        },
        // emphasis: {
        //   focus: 'series'
        // },
        data: [1777657207, 1757890245, 1775213465, 1851600000]
      },
      {
        name: 'Expense',
        type: 'line',
        stack: 'Total',
        label: {
          show: false,
          position: 'top',
          color: '#fff'
        },
        areaStyle: {},
        // emphasis: {
        //   focus: 'series'
        // },
        data: [1706443552, 1672957566, 1800313940, 1806200000]
      }
    ]
  };

  return (
    <div className="bg-[#0F0D0B] text-[#fff] h-[100%] rounded-[7px]">
      <div className="relative h-[190px]">
        <div className=" h-[180px] ">
          <img src={Finance_bannerImg} className="h-[190px] w-full " />
        </div>
        <div className="w-full absolute bottom-0 h-[40px] bg-[#0f0d0bb3] py-2 px-3">
          <h3 className="text-[16.2px] text-[#fff]">Financial Information <span className="text-[10.2px] text-[#fff]"></span></h3>
        </div>

      </div>
      <LoaderContainer height={"70px"} width={"100%"} loading={Financial_top_tileDataloading} className="mt-2 mb-2">
        <div className="grid grid-cols-2 gap-10 px-5 mt-5 mb-2 gap_reduce">
          <div className="flex items-start gap-3">

            <div className="pt-2">
              <p className="text-[14px] text-[#ebebeb] font-light opacity-80 mb-1">
                Revenue</p>
              <div className="flex items-center gap-5 reduce_inner_gap">
                {/* <h4 className="text-[13px] text-[#fff]">$1851.6 M</h4> */}
                <h4 className="text-[16px] font-semibold text-[#fff]">{toMillion(parseFloat(Revenue?.VALUE?.replaceAll(",", '')))}</h4>
                {/* <div className='h-4 trendingdown'>
                  <img src={TreadingarrowDown} className="" /> -0.1%</div> */}
              </div>
            </div>
          </div>


          <div className="flex items-start gap-3">

            <div className="pt-2">
              <p className="text-[14px] text-[#ebebeb] font-light opacity-80 mb-1">
                Expense</p>

              <div className="flex items-center gap-3 reduce_inner_gap">
                {/* <h4 className="text-[13px] text-[#fff]">$1806.2 M</h4> */}
                <h4 className="text-[16px] font-semibold text-[#fff]">{toMillion(parseFloat(Expenses?.VALUE?.replaceAll(",", '')))}</h4>
                {/* <div className='h-4 trendingup'>
                  <img src={TreadingarrowUp} className="" /> 0.2%</div> */}
              </div>

            </div>


          </div>
        </div>
      </LoaderContainer>
      <div className="grid grid-cols-1 items-center  mb-4 border-t border-[#ffffff26] finnace_main">
        <LoaderContainer height={"130px"} width={"100%"} loading={Financial_Total_Revenue_piechartloading} className="FinInfo2 mb-4">
          <div className="FinInfo2 mx-auto">
            <MyChart options={FinInfo1}
             opts={{
        renderer: "canvas",
        devicePixelRatio: window.devicePixelRatio || 2,
      }}/>
            {/* <ReactEcharts style={{ width: 350 }} option={FinInfo1} /> */}
          </div>
        </LoaderContainer>
        <LoaderContainer height={"130px"} width={"100%"} loading={Financial_Total_Expenses_piechartloading} className="FinInfo2">

          <div className="FinInfo2 mx-auto">
            <MyChart options={FinInfo2} />
            {/* <ReactEcharts style={{ width: 350 }} option={FinInfo2} /> */}
          </div>
        </LoaderContainer>
      </div>
      {/* <div className="border-t border-[#ffffff26]">
        <LoaderContainer height={"110px"} width={"100%"} loading={false} className="FinInfo1">

          <div className="mb-0 RevenueExpense">
            <ReactEcharts style={{ width: 280 }} option={RevenueExpense} />
          </div>
        </LoaderContainer>
      </div> */}



    </div>
  )
}